export default __webpack_public_path__ + "static/media/7_1.a54b69a3.jpg";